import React, { Component, Fragment } from "react";
import "./style.css";
import * as d3 from "d3";
// import moment from "moment";
import $ from "jquery";
import { Fun } from "./functions.js";

class Scatter extends Component {
  componentDidMount() {
    var { id, width, height, MainData } = this.props;

    var Benchmark = MainData[1];
    var Portfolio = MainData[0];

    let ChartData = Fun.MainDataModify(Portfolio, Benchmark);
    let data = ChartData;
    this.chartDisplay(id, data, MainData, width, height);
  }
  componentWillReceiveProps(props) {
    var { id, width, height, MainData } = props;
    var Benchmark = MainData[1];
    var Portfolio = MainData[0];
    $(`#${id}`).empty();
    let ChartData = Fun.MainDataModify(Portfolio, Benchmark);
    let data = ChartData;
    this.chartDisplay(id, data, MainData, width, height);
  }

  chartDisplay = (id, data, MainData, width, height) => {
    var margin = { top: 20, right: 20, bottom: 30, left: 70 },
      w = width - margin.left - margin.right,
      h = height - margin.top - margin.bottom;
    var Id = `#${id}`;
    var Benchmark = MainData[1];
    var Portfolio = MainData[0];
    // setup x
    var xValue = function(d) {
      return d.value;
    };

    // a = d3.extent(portfolio, d=>d[1])

    var extent = data => {
      let x = d3.extent(data, d => d["value"] + 100);
      let d = [x[0]/1.05,x[1]]
      return d;
    };

    // var xValue = function(d) {
    // return d.Calories;
    // }, // data -> value

    var xScale = d3.scale.linear().range([0, w]); // value -> display
    var xMap = function(d) {
      return xScale(xValue(d));
    };
    var xAxis = d3.svg
      .axis()
      .scale(xScale)
      .orient("bottom");

    // setup y
    var yValue2 = function(d) {
        return d.value;
      }, // data -> value
      yScale = d3.scale.linear().range([h, 0]), // value -> display
      yMap = function(d) {
        return yScale(yValue2(d));
      }, // data -> display
      yAxis = d3.svg
        .axis()
        .scale(yScale)
        .orient("left");

    // setup fill color
    var cValue = function(d) {
      return d.name;
    };
    // color = d3.scale.category10();
    var color = d3.scale.ordinal().range(["#81efde", "#4c6ead"]);

    // add the graph canvas to the body of the webpage
    var svg = d3
      .select(Id)
      .append("svg")
      .attr("width", w + margin.left + margin.right)
      .attr("height", h + margin.top + margin.bottom)
      .append("g")
      .attr("transform", "translate(" + margin.left + "," + margin.top + ")");

    // add the tooltip area to the webpage
    var tooltip = d3
      .select(Id)
      .append("div")
      .attr("class", "scatter_tooltip")
      .style("opacity", 0);

    if (data) {
      // don't want dots overlapping axis, so add in buffer to data domain
      // xScale.domain(
      //   d3.extent(data, function(d) {
      //     // return new Date(d.date);
      //     return parseInt(moment(d.date, "YYYY-MM-DD").format("x"));
      //   })
      // );

      xScale.domain(extent(data));
      yScale.domain(extent(data));
      // x-axis
      svg
        .append("g")
        .attr("class", "scatter_x_axis")
        .attr("transform", "translate(0," + h + ")")
        .call(xAxis
        .tickFormat(d3.format("s")))
        .append("text")
        .attr("class", "label")
        .attr("x", w)
        .attr("y", -6)
        .style("text-anchor", "end")
        .text("Benchmark");

      // y-axis
      svg
        .append("g")
        .attr("class", "scatter_y_axis")
        .call(yAxis
        .tickFormat(d3.format("s")))
        .append("text")
        .attr("class", "label")
        .attr("transform", "rotate(-90)")
        .attr("y", 6)
        .attr("dy", ".71em")
        .style("text-anchor", "end")
        .text("Portfolio");

      // draw dots
      svg
        .selectAll(".dot")
        .data(data)
        .enter()
        .append("circle")
        .attr("class", "scatter_dot")
        .attr("r", 3.5)
        .attr("cx", function(d) {
          // console.log(d);
          return xScale(xValue(d));
        })
        .attr("cy", yMap)
        .style("fill", function(d) {
          return color(cValue(d));
        })
        // .attr("opacity", 1)
        .on("mouseover", function(d) {
          var matrix = this.getScreenCTM().translate(
            +this.getAttribute("cx"),
            +this.getAttribute("cy")
          );

          tooltip
            .transition()
            .duration(200)
            .style("opacity", 0.8);
          tooltip
            .html(d["name"] + "<br/> (" + xValue(d).toFixed(2) + ", " + yValue2(d).toFixed(2) + ")")
            // .style("left", `${xMap} px`)
            // .style("top", `${yMap} px`)
            .style("left", window.pageXOffset + matrix.e - 100 + "px")
            // .style("top", window.pageYOffset + matrix.f - 30 + "px")
            .style("top", d3.select(this).attr("cy") + "px")
            .style("color", "#fff")
            .style("background-color", "#000")
            .style("opacity",0.8);
        })
        .on("mouseout", function(d) {
          tooltip
            .transition()
            .duration(500)
            .style("opacity", 0);
        });
    }
  };
  render() {
    return <div id={this.props.id} />;
  }
}

export default Scatter;



// WEBPACK FOOTER //
// ./src/components/d3Components/scatterPlot/Scatter.jsx